interface BulletListBlockProps {
  content: {
    title?: string;
    subtitle?: string;
    items?: string[];
    showDivider?: boolean;
  };
}

export function BulletListBlock({ content }: BulletListBlockProps) {
  return (
    <section className="mx-auto max-w-[1200px] px-6 py-16">
      {content.showDivider && (
        <div className="mb-12 h-px w-16 bg-border" />
      )}
      {content.title && (
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-3">
          {content.title}
        </h2>
      )}
      {content.subtitle && (
        <p className="font-sans text-sm text-muted-foreground mb-8 max-w-[700px]">
          {content.subtitle}
        </p>
      )}
      {content.items && content.items.length > 0 && (
        <ul className="space-y-3 max-w-[800px]">
          {content.items.map((item, i) => (
            <li key={i} className="flex items-start gap-3 font-sans text-base leading-relaxed text-muted-foreground">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-foreground/40" />
              {item}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
